{
  "addDevice": {
    "addButton": "Add Device",
    "description": "Only Device Serial Number is required.",
    "successDescription": "Device has been registered. Save the Serial Number and Token securely.",
    "successTitle": "Device Created Successfully",
    "title": "Add New Device"
  },
  "app": {
    "title": "Wonder Forest"
  },
  "auth": {
    "loggingIn": "Signing in...",
    "login": "Sign in",
    "loginButton": "Sign In",
    "loginError": "Invalid credentials",
    "password": "Password",
    "username": "Username"
  },
  "analytics": {
    "title": "Analytics",
    "filters": "Filters",
    "selected": "selected",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "selectDevices": "Select devices...",
    "sunburstTitle": "Detection Analytics",
    "selectDevicesToView": "Select devices to view analytics",
    "deviceAvailability": {
      "title": "Device availability",
      "description": "Share of the period each selected device held an open connection to the platform.",
      "loading": "Loading availability...",
      "failed": "Failed to load device availability.",
      "retry": "Retry",
      "retrying": "Retrying...",
      "narrowPeriod": "Too much connection history to show. Narrow the period.",
      "noAccess": "You do not have access to one of the selected devices.",
      "notFound": "One of the selected devices no longer exists.",
      "timelineLabel": "Availability timeline of {label}",
      "empty": "No devices to show.",
      "noData": "No availability data for this period.",
      "average": "Average availability: {value}",
      "worst": "Lowest: {label} ({value})",
      "disconnects": "Disconnects",
      "downtime": "Downtime",
      "longestDowntime": "Longest downtime",
      "needsDevices": "Select at least one device.",
      "needsFrom": "Set the start of the period.",
      "tooManyDevices": "Select at most {max} devices.",
      "fromInFuture": "The start of the period must be in the past.",
      "toBeforeFrom": "The end of the period must be after its start.",
      "rangeTooLong": "The period must not exceed {max} days."
    },
    "suppressionsReport": {
      "title": "Suppressions report",
      "description": "Downloads a CSV of every suppression for the selected devices and period, regardless of status.",
      "download": "Download CSV",
      "downloading": "Downloading...",
      "needsDevices": "Select at least one device.",
      "needsFrom": "Set the start of the period.",
      "fromInFuture": "The start of the period is in the future.",
      "tooManyDevices": "Select at most {max} devices.",
      "toBeforeFrom": "The end of the period must be after its start.",
      "rangeTooLong": "The period must not exceed {max} days.",
      "tooManyRows": "Too many suppressions to export ({rows}, limit {maxRows}). Narrow the period or the devices.",
      "tooManyRowsAtExport": "Too many suppressions to export. Narrow the period or the devices.",
      "failed": "Failed to download the report."
    }
  },
  "common": {
    "apply": "Apply",
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "edit": "Edit",
    "error": "Error",
    "loading": "Loading...",
    "next": "Next",
    "previous": "Previous",
    "reset": "Reset",
    "retry": "Retry",
    "save": "Save",
    "saving": "Saving...",
    "submit": "Submit",
    "success": "Success",
    "unexpectedError": "Unexpected error",
    "unknownError": "Unknown error"
  },
  "detectionGroups": {
    "eventsTab": "Events",
    "eventsLoading": "Loading events…",
    "eventsError": "Failed to load events",
    "eventsEmpty": "No events recorded in this detection group."
  },
  "detections": {
    "allModes": "All modes",
    "devices": "Devices",
    "error": "Failed to load detections",
    "errorLoadingDevices": "Error loading devices",
    "expandToLoad": "Expand to load detections…",
    "failedToLoad": "Failed to load detections",
    "filter": {
      "fromDate": "Start Date",
      "toDate": "End Date"
    },
    "loading": "Loading detections...",
    "loadingDetections": "Loading detections…",
    "loadingDevices": "Loading devices...",
    "noDetectionsForDevice": "No detections for this device.",
    "noDevicesAvailable": "No devices available.",
    "visualize": "Analytics",
    "visualizationTitle": "Detection Groups Visualization - {serial}",
    "visualizationLegend": "How to read this chart:",
    "visualizationLegend.level1": "Inner circle",
    "visualizationLegend.level2": "Middle circle",
    "visualizationLegend.level3": "Outer circle",
    "visualizationLegend.suppressionStatus": "Suppression status (Suppressed / Not Suppressed)",
    "visualizationLegend.signalType": "Signal type (Analog / Digital)",
    "visualizationLegend.frequencyRange": "Frequency ranges (1-2 MHz, 2-3 MHz, etc.)",
    "visualizationLegend.clickToZoom": "Click on any segment to zoom in. Click the center to zoom out.",
    "errorLoadingData": "Error loading visualization data",
    "suppress": "Suppress",
    "suppressionMode": "Suppression Mode",
    "related": {
      "title": "Linked devices",
      "noRelatedDevices": "No linked devices available.",
      "compactTitle": "Linked Device Detections - {serial}",
      "loading": "Loading linked device detection groups…",
      "failedToLoad": "Failed to load linked device detection groups",
      "noGroups": "No detection groups for this device.",
      "suppressOnMain": "Suppress",
      "suppressionCreated": "Suppression created from {serial} at {frequency} MHz."
    },
    "table": {
      "bandwidth": "Bandwidth, MHz",
      "count": "Count",
      "details": "Details",
      "motion": "Motion",
      "identity": "Identity",
      "confidenceShort": "Conf",
      "trackPending": "Tracking data pending",
      "track": {
        "avgLevel": "Avg Level",
        "avgSnr": "Avg SNR",
        "levelSlope": "Level Slope",
        "snrSlope": "SNR Slope",
        "detectionRate": "Detection Rate",
        "suppressionCount": "Suppressions",
        "signalMetrics": "Signal Metrics",
        "identityNote": "Based on suppression history and signal stability"
      },
      "direction": "Direction",
      "directions": {
        "unknown": "Unknown",
        "approaching": "Approaching",
        "receding": "Receding"
      },
      "motionDirections": {
        "unknown": "Unknown",
        "approaching": "Approaching",
        "receding": "Receding",
        "static": "Static"
      },
      "identityRules": {
        "unknown": "Unknown",
        "hostile": "Hostile",
        "friendly": "Friendly",
        "neutral": "Neutral"
      },
      "frequency": "Frequency, MHz",
      "lastSeen": "Last Seen",
      "timestamp": "Timestamp",
      "offset": "Offset, MHz",
      "pattern": "Pattern",
      "showing": "Showing {start}–{end} of {total}",
      "signalLevel": "Signal Level, dB",
      "snr": "SNR, dB",
      "status": "Status",
      "type": "Type",
      "window": "Window",
      "actions": "Actions",
      "startSuppression": "Suppress",
      "priority": "Priority",
      "suppressionDuration": "Duration (sec)",
      "suppressionBandwidth": "Width (MHz)",
      "secondsSuffix": "sec",
      "mhzSuffix": "MHz",
      "stopSuppression": "Stop",
      "editFrequency": "Edit frequency",
      "changeFrequency": "Change",
      "changingFrequency": "Changing...",
      "changeFrequencyConfirm": {
        "title": "Change Suppression Frequency",
        "description": "This will stop the current suppression at {oldFrequency} MHz and start a new one at {newFrequency} MHz with the same initial duration. Are you sure?"
      },
      "expandChildren": "Expand children",
      "repeatSuppression": "Repeat suppression",
      "repeatSuppressionTooltipOffline": "Device must be online to repeat a suppression",
      "repeatSuppressionTooltipLoading": "Device settings are still loading",
      "repeatSuppressionTooltipUnavailable": "Device settings are unavailable",
      "repeatSuppressionFailed": "Failed to repeat the suppression"
    },
    "title": "Detections - {deviceSerialNumber}",
    "multiFrequency": {
      "badge": "Multi-frequency",
      "badgeTooltip": "Multi-frequency suppression across {count, plural, one {# frequency} other {# frequencies}}",
      "badgeTooltipUnknown": "Multi-frequency suppression",
      "frequencies": "Suppressed frequencies ({count})",
      "signalType": "Signal type",
      "bandwidth": "Bandwidth",
      "bandwidthValue": "{value} MHz",
      "stepStandingTime": "Step standing time",
      "stepStandingTimeValue": "{value} ms",
      "duration": "Duration",
      "durationValue": "{value} s",
      "startedAt": "Start time",
      "finishedAt": "End time",
      "unavailable": "Suppression details unavailable",
      "stopTooltip": "Stop the multi-frequency suppression",
      "stopTooltipOffline": "Device must be online to stop a multi-frequency suppression",
      "stopFailed": "Failed to stop the multi-frequency suppression",
      "stopFailedDeviceOffline": "Device is offline — the multi-frequency suppression was not stopped",
      "stopFailedDeviceNotFound": "Device not found — the multi-frequency suppression was not stopped",
      "repeat": "Repeat the multi-frequency suppression",
      "repeatTooltipOffline": "Device must be online to repeat a multi-frequency suppression",
      "repeatTooltipNoSnapshot": "Suppression details unavailable — cannot repeat",
      "repeatFailed": "Failed to repeat the multi-frequency suppression"
    }
  },
  "deviceCard": {
    "activeSuppressions": {
      "label": "Active suppressions: {count}",
      "offlinePrefix": "Device offline — last known suppressions",
      "kind": {
        "regular": "Regular",
        "broadband": "Broadband"
      },
      "frequency": "{value} MHz",
      "frequencyRange": "{start}–{stop} MHz",
      "frequencyList": "{count} frequencies",
      "remaining": "{remaining} left",
      "startedAt": "started {time}"
    },
    "control": "Control",
    "copySerial": "Copy serial number",
    "copyToken": "Copy token",
    "details": "Details",
    "deviceMustBeOnline": "Device must be online to suppress",
    "deviceSettings": "Device settings",
    "firmware": "Firmware",
    "hideToken": "Hide token",
    "lastSeen": "Last Seen",
    "observer": "Observer",
    "openEmulator": "Open emulator",
    "viewEvents": "Event log",
    "popupBlocked": "Popup blocked! Please allow popups for this site and try again.",
    "hideOnMap": "Hide on map",
    "showOnMap": "Show on map",
    "showToken": "Show token",
    "suppress": "Suppress",
    "suppressSignals": "Suppress signals",
    "txDisabled": "TX Disabled",
    "txEnabled": "TX Enabled",
    "unknownModel": "Unknown Model"
  },
  "deviceTelemetry": {
    "button": "Telemetry",
    "title": "Telemetry – {serial}",
    "filters": {
      "metrics": "Metrics",
      "selectMetrics": "Select metrics...",
      "fromDate": "From",
      "toDate": "To",
      "refreshInterval": "Refresh",
      "intervals": {
        "30000": "30 seconds",
        "60000": "1 minute",
        "300000": "5 minutes",
        "600000": "10 minutes",
        "1800000": "30 minutes"
      }
    },
    "chart": {
      "noData": "No data for this period",
      "loading": "Loading..."
    },
    "metrics": {
      "power_supply_voltage": "220V Power Supply Voltage",
      "battery_voltage": "Battery Voltage",
      "power_amplifier_1_current": "Power Amplifier 1 Current",
      "power_amplifier_2_current": "Power Amplifier 2 Current",
      "power_amplifier_1_temperature": "Power Amplifier 1 Temperature",
      "power_amplifier_2_temperature": "Power Amplifier 2 Temperature",
      "device_temperature": "Device Temperature",
      "device_humidity": "Device Humidity",
      "cpu_temperature": "CPU Temperature",
      "cpu_usage": "CPU Usage",
      "memory_usage": "Memory Usage",
      "bridge_temperature": "Bridge Temperature"
    },
    "units": {
      "volt": "V",
      "ampere": "A",
      "degree_celsius": "°C",
      "percent": "%"
    }
  },
  "deviceEvents": {
    "title": "Event log — {serial}",
    "description": "Device event history",
    "filters": {
      "messageType": "Message type",
      "allTypes": "All types",
      "fromDate": "Created after",
      "toDate": "Created before",
      "apply": "Apply filters",
      "reset": "Reset filters"
    },
    "table": {
      "timestamps": "Timestamps",
      "messageType": "Message type",
      "errors": "Errors",
      "payload": "Payload"
    },
    "version": "Version",
    "messageInitiatedAt": "Message initiated at",
    "clockSkew": "Device clock differs from server",
    "eventId": "Event ID",
    "acknowledged": "Acknowledged",
    "waitingAck": "Waiting for ACK",
    "noAck": "Pending",
    "loading": "Loading events...",
    "failedToLoad": "Failed to load events",
    "noEvents": "No events for this device yet",
    "pagination": "Showing {start}–{end} of {total} events",
    "refreshing": "Updating...",
    "messageTypes": {
      "channels_table": "Channels table",
      "device_config": "Device config",
      "device_settings": "Device settings",
      "device_settings_update": "Device settings update",
      "device_telemetry": "Device telemetry",
      "detections": "Detections",
      "forced_suppression": "Forced suppression",
      "frequency_whitelist_update": "Frequency whitelist update",
      "get_suppressions_queue": "Get suppressions queue",
      "stop_suppression": "Stop suppression",
      "suppressions": "Suppressions",
      "suppressions_queue": "Suppressions queue",
      "update_firmware": "Firmware update",
      "update_firmware_status": "Firmware update status"
    }
  },
  "deviceCreated": {
    "close": "Close",
    "copy": "Copy",
    "serial": "Serial",
    "successMessage": "Device successfully registered!",
    "token": "Token",
    "warning": "Save these credentials securely. The token will not be shown again."
  },
  "deviceSettings": {
    "contactAdminForLocation": "Contact your administrator to update location and orientation settings.",
    "description": "Configure and manage device settings.",
    "device": "Device",
    "fields": {
      "friendOrFoeMinCalculationTime": "Min Calculation Time (seconds)",
      "friendOrFoeMaxCalculationTime": "Max Calculation Time (seconds)",
      "suppressionLogic": {
        "label": "Suppression Logic",
        "values": {
          "all_detections": "All Detections",
          "approaching_only": "Approaching Only",
          "approaching_and_unknown": "Approaching and Unknown"
        }
      },
      "suppressionMode": {
        "auto": {
          "label": "Auto",
          "description": "Automatic suppression"
        },
        "disabled": {
          "label": "Disabled",
          "description": "No suppression"
        },
        "label": "Suppression Mode",
        "manual": {
          "label": "Manual",
          "description": "Manual suppression only"
        }
      },
      "directionality": {
        "label": "Coverage direction",
        "circular": {
          "label": "Circular"
        },
        "directional": {
          "label": "Directional"
        }
      },
      "multiChannelsSuppress": {
        "label": "Multi Channels Suppress",
        "1": "Single channel",
        "2": "Dual channels",
        "3": "Triple channels"
      },
      "maxSuppressionTime": "Max suppression time (seconds)",
      "suppressionTime": "Single suppression cycle time (seconds)",
      "suppressionMaxCount": "Suppression Max Count",
      "suppressionInitialDelay": "Suppression Initial Delay (seconds)",
      "suppressionMinDetectionsCount": "Suppression Min Detections Count",
      "suppressionMinSnr": "Suppression Min SNR",
      "suppressionAttemptDelay": "Delay until next suppression attempts (seconds)",
      "txGainDecreaseLevel": "TX Gain Decrease Level (dB)",
      "txGainDecreaseLevelHelp": "For indoor testing, recommended value: 30-40",
      "jumperMode": "Jumper mode",
      "jumperModeHelp": "Enable jumper sessions for this device. When disabled, no new jumper sessions can be started.",
      "sapientEnabled": "SAPIENT integration",
      "detectionLifetime": "Grouping detection delay (seconds)",
      "detectionLifetimeHelp": "Time window to group detections together for suppression. Detections within this time frame will be considered part of the same event.",
      "minAllowedFrequency": "Min Allowed Frequency (MHz)",
      "maxAllowedFrequency": "Max Allowed Frequency (MHz)",
      "defaultAnalogSuppressionBandwidth": "Default analog suppression bandwidth (MHz)",
      "defaultDigitalSuppressionBandwidth": "Default digital suppression bandwidth (MHz)",
      "defaultAnalogMultiFrequencySuppressionBandwidth": "Default multi-frequency suppression bandwidth (analog) (MHz)",
      "defaultDigitalMultiFrequencySuppressionBandwidth": "Default multi-frequency suppression bandwidth (digital) (MHz)",
      "defaultMultiFrequencySuppressionSignalType": "Default multi-frequency signal type",
      "defaultBroadbandSuppressionMode": {
        "label": "Default broadband suppression mode",
        "solid": {
          "label": "Solid"
        },
        "hopping": {
          "label": "Hopping"
        }
      },
      "latitude": "Latitude",
      "longitude": "Longitude",
      "azimuth": "Azimuth (degrees)",
      "elevation": "Elevation (meters)",
      "tags": "Tags",
      "model": "Model",
      "modelUnknown": "Unknown",
      "currentFirmwareVersion": "Current Version",
      "firmwareVersionUnknown": "Unknown",
      "firmwareUpdateTo": "Update to {version}",
      "firmwareUpdating": "Updating...",
      "firmwareStatus": {
        "downloading_started": "Downloading firmware {version}...",
        "downloading_finished": "Firmware {version} downloaded successfully",
        "downloading_failed": "Failed to download firmware: {reason}",
        "started": "Installing firmware {version}...",
        "finished": "Firmware updated to {version}",
        "failed": "Firmware update failed: {reason}"
      },
      "deviceType": {
        "label": "Device Type",
        "detector": {
          "label": "Detector",
          "description": "Detection only, no suppression capability"
        },
        "detector_suppressor": {
          "label": "Detector-Suppressor",
          "description": "Detection and suppression capabilities"
        }
      },
      "alertPatterns": "Alert patterns"
    },
    "scanRanges": {
      "addChannel": "Add Channel",
      "addRange": "Add Range",
      "band": "Band",
      "bandLabel": "Band",
      "capabilityMissing": "This device does not support scan ranges.",
      "cancel": "Cancel",
      "channel": "Channel",
      "channels": "Channels",
      "clear": "Clear",
      "description": "Configure frequency channels and ranges for this device",
      "digital": "Digital",
      "enabled": "Enabled",
      "endFreq": "End (MHz)",
      "freqMhz": "Freq (MHz)",
      "genericSubmitError": "Failed to update device scan ranges.",
      "group": "Group",
      "import": "Import",
      "importError": "Failed to import frequency table. Please check the file format.",
      "loadError": "Failed to load frequency table",
      "loading": "Loading frequency table...",
      "noChannels": "No channels configured",
      "noRanges": "No ranges configured",
      "ranges": "Scan ranges",
      "save": "Save Changes",
      "startFreq": "Start (MHz)",
      "step": "Step (MHz)",
      "title": "Scan ranges"
    },
    "loadError": "Failed to load settings",
    "loading": "Loading device settings…",
    "saving": "Saving…",
    "sections": {
      "detection": {
        "title": "Detection Settings",
        "description": "Configure detection parameters and frequency ranges"
      },
      "general": {
        "title": "General Settings",
        "description": "Configure suppression behavior and detection parameters"
      },
      "location": {
        "title": "Location & Orientation",
        "description": "Set device geographical position and antenna orientation"
      },
      "testing": {
        "title": "Testing Settings",
        "description": "Configure device testing parameters"
      },
      "tags": {
        "title": "Tags",
        "description": "Manage device tags for organization and filtering"
      },
      "linkedDevices": {
        "title": "Linked Devices",
        "description": "Attach additional Devices to this complex to receive more detections from neighboring complexes"
      },
      "friendOrFoe": {
        "title": "Friend Or Foe Settings",
        "description": "Control Friend Or Foe detection behavior"
      },
      "device": {
        "title": "Device",
        "description": "Device model information and firmware updates"
      },
      "alertPatterns": {
        "title": "Alert patterns",
        "description": "Alert pattern names this device watches for. Names are stored lowercase."
      }
    },
    "tabs": {
      "settings": "Settings",
      "whitelist": "Whitelist",
      "scanRanges": "Scan ranges"
    },
    "title": "Device Settings",
    "reboot": "Reboot",
    "rebootConfirmation": "Are you sure you want to reboot this device?",
    "unregister": "Unregister",
    "unregisterConfirmation": "Are you sure you want to unregister this device? This action cannot be undone.",
    "unregisterDevice": "Unregister Device",
    "unregistering": "Unregistering…",
    "alertPatterns": {
      "placeholder": "Type a pattern name and press Enter",
      "remove": "Remove pattern {pattern}"
    },
    "family": {
      "label": "Device family",
      "hint": "Choose the family that matches the physical device. It cannot be changed later.",
      "hintNonAdmin": "The device family is not set. Ask an administrator to set it before changing settings.",
      "settingsLocked": "Set the device family to configure settings. Tags can be saved now.",
      "assignFailed": "Failed to set the device family. Try again.",
      "confirmTitle": "Set the device family?",
      "confirmBody": "Set the family to {family}? It must match the physical device and cannot be changed later.",
      "confirm": "Set family",
      "alreadySet": "This device has already reported its family. Its settings are available now."
    },
    "errors": {
      "familyRequired": "Set the device family before configuring settings. Nothing was saved.",
      "profileNotReady": "The device profile is not ready yet. Nothing was saved; try again shortly.",
      "saveFailed": "Failed to save device settings. Nothing was saved."
    }
  },
  "deviceTags": {
    "addError": "Failed to add tag",
    "alreadyAssigned": "Tag '{name}' is already assigned",
    "createLabel": "Create {value}",
    "loadError": "Failed to load tags",
    "loading": "Loading tags…",
    "noTags": "No tags assigned",
    "placeholder": "Add a tag…",
    "removeError": "Failed to remove tag",
    "removeTag": "Remove tag {name}",
    "maxReached": "Maximum {max} tags per device"
  },
  "deviceLinkedDevices": {
    "addError": "Failed to add device link",
    "removeError": "Failed to remove device link",
    "noLinkedDevices": "No linked devices",
    "placeholder": "Add a device…",
    "removeDevice": "Remove linked device {serial}",
    "noAvailableDevices": "No available devices"
  },
  "userGrants": {
    "label": "Device access",
    "noGrants": "No tags assigned",
    "placeholder": "Search or create a tag...",
    "createLabel": "Create \"{value}\"",
    "alreadyAssigned": "{name} is already assigned",
    "removeTag": "Remove tag {name}",
    "roleFor": "Role for {name}",
    "role": {
      "operator": "Operator",
      "observer": "Observer"
    },
    "footnote": "Access applies to every device carrying the tag. Observers view; operators can also control.",
    "maxReached": "Maximum {max} tags per user",
    "maxLength": "Tag name must be 64 characters or fewer",
    "createError": "Failed to create tag",
    "columnTag": "Tag",
    "columnRole": "Role",
    "defaultRoleHint": "Observer by default",
    "deviceCount": "{count, plural, one {# device} other {# devices}}",
    "summaryTagsOnly": "{tags, plural, one {# tag} other {# tags}}",
    "summary": "{tags, plural, one {# tag} other {# tags}} · {devices, plural, one {# device} other {# devices}}"
  },
  "deviceWhitelist": {
    "addRange": "Add Range",
    "allowedRange": "Allowed range: {min} - {max} MHz",
    "currentVersion": "Current version: {version} ({date})",
    "description": "Manage allowed frequencies for device.",
    "fetchingRanges": "Fetching saved ranges…",
    "invalidEntry": "Invalid whitelist entry",
    "loadError": "Failed to load whitelist: {error}",
    "loadingDescription": "Loading whitelist data for device…",
    "maxFrequency": "Max frequency: {max} MHz",
    "minFrequency": "Min frequency: {min} MHz",
    "noLimits": "No frequency limits configured",
    "noRanges": "No ranges added yet.",
    "ranges": "Ranges",
    "removeRange": "Remove range",
    "setError": "Failed to set device whitelist",
    "startMhz": "Start, MHz",
    "stopMhz": "Stop, MHz",
    "title": "{serial} - Frequency Whitelist"
  },
  "devices": {
    "actions": "Actions",
    "addDevice": "Add Device",
    "addDeviceDesc": "Only Device Serial Number is required.",
    "addNewDevice": "Add New Device",
    "cancel": "Cancel",
    "clearSelection": "Clear selection",
    "resizeMap": "Resize map",
    "confirmDelete": "Delete Device",
    "confirmDeleteDesc": "Are you sure you want to delete device {serial}? This action cannot be undone.",
    "copySerial": "Copy Serial Number",
    "copyToken": "Copy token",
    "create": "Create",
    "creating": "Creating...",
    "delete": "Delete",
    "deleting": "Deleting...",
    "deviceCreated": "Device Created Successfully",
    "deviceCreatedDesc": "Device has been registered. Save the Serial Number and Token securely.",
    "edit": "Edit",
    "error": "Failed to load devices",
    "lastSeen": "Last Seen",
    "loading": "Loading devices...",
    "map": "Map",
    "noDevices": "No devices found. Add your first device to get started.",
    "refresh": "Refresh",
    "refreshing": "Refreshing...",
    "serial": "Serial Number",
    "serialCopied": "Serial Number copied",
    "settings": "Settings",
    "status": "Status",
    "title": "Devices",
    "tokenCopied": "Token copied"
  },
  "devicesList": {
    "errorLoading": "Error loading devices",
    "filterByTags": "Filter by tags",
    "loadingDevices": "Loading devices...",
    "noDevicesFound": "No devices found",
    "noDevicesMatchingSerial": "No devices matching '{query}'",
    "onlineOnly": "Online only",
    "pagination": "Showing {start}–{end} of {total}",
    "perPage": "{count} per page",
    "refresh": "Refresh",
    "refreshing": "Refreshing...",
    "serialSearchLabel": "Search by serial",
    "serialSearchPlaceholder": "Search by serial number",
    "showAllOnMap": "Show All on Map ({count})",
    "showDevicesOnMap": "Show {count} devices on map",
    "title": "Devices"
  },
  "map": {
    "azimuth": "Azimuth",
    "coordinates": "Coordinates",
    "disabled": "Disabled",
    "elevation": "Elevation (meters)",
    "enabled": "Enabled",
    "lastSeen": "Last Seen",
    "status": {
      "online": "Online",
      "offline": "Offline",
      "unknown": "Unknown"
    },
    "tx": "TX"
  },
  "nav": {
    "alertSound": {
      "blockedHint": "Click to enable alert sound",
      "label": "Notification sound",
      "off": "Notification sound: off",
      "on": "Notification sound: on"
    },
    "appName": "Wonder Forest",
    "analytics": "Analytics",
    "devices": "Devices",
    "firmwares": "Firmwares",
    "loggingOut": "Logging out…",
    "logout": "Logout",
    "profile": "Profile",
    "users": "Users"
  },
  "newDeviceForm": {
    "cancel": "Cancel",
    "createDevice": "Create Device",
    "createError": "Failed to create device. Please try again.",
    "creating": "Creating...",
    "serialNumber": "Serial Number",
    "serialNumberPlaceholder": "Enter Serial Number",
    "deviceType": "Device Type",
    "deviceFamily": "Device Family",
    "familyKvitka": "Kvitka",
    "familyKvitkaDescription": "Detector or detector-suppressor",
    "familySunflower": "Sunflower",
    "familySunflowerDescription": "Broadband suppression"
  },
  "profile": {
    "title": "Profile",
    "username": "Username",
    "role": "Role",
    "access": "Access",
    "createdAt": "Created At",
    "changePassword": {
      "title": "Change password",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "updateButton": "Update password",
      "updating": "Updating...",
      "successMessage": "Password updated successfully",
      "errorMessage": "Failed to change password"
    }
  },
  "signalType": {
    "analog": "Analog",
    "digital": "Digital"
  },
  "suppressDialog": {
    "row": {
      "whitelistWarning": "This frequency is in the device whitelist"
    }
  },
  "suppressionsTable": {
    "duration": "Duration",
    "endedAt": "Ended At",
    "frequency": "Frequency, MHz",
    "ongoing": "ongoing",
    "reason": "Reason",
    "seconds": "s",
    "startedAt": "Started At",
    "status": "Status",
    "statusActive": "Active",
    "statusEnded": "Ended",
    "statusStopped": "Stopped",
    "success": "Success",
    "type": "Type"
  },
  "userDialog": {
    "action": {
      "cancel": "Cancel",
      "creating": "Creating...",
      "saving": "Saving...",
      "create": "Create User",
      "save": "Save Changes"
    },
    "field": {
      "username": "Username",
      "usernamePlaceholder": "jane.doe",
      "usernameHint": "Allowed: letters, numbers, dot, hyphen, underscore.",
      "temporaryPassword": "Temporary Password",
      "resetPassword": "Reset Password",
      "passwordPlaceholder": "min 6 characters",
      "passwordPlaceholderEdit": "leave blank to keep current password",
      "passwordHintEdit": "Fill to set a new password, or leave empty to keep the current one.",
      "administrator": "Administrator",
      "administratorHint": "An administrator can access every device."
    },
    "role": {
      "admin": "Admin",
      "member": "Member"
    },
    "title": {
      "add": "Add User",
      "edit": "Edit User"
    }
  },
  "users": {
    "accessDenied": "Access Denied",
    "accessDeniedDesc": "You don't have permission to view this page.",
    "actions": "Actions",
    "addNewUser": "Add New User",
    "addUser": "Add User",
    "cancel": "Cancel",
    "confirmDelete": "Delete User",
    "confirmDeleteDesc": "Are you sure you want to delete user {username}? This action cannot be undone.",
    "createdAt": "Created At",
    "delete": "Delete",
    "deleting": "Deleting...",
    "edit": "Edit",
    "editUser": "Edit User",
    "error": "Failed to load users",
    "loading": "Loading users...",
    "loadingAccount": "Loading account...",
    "refresh": "Refresh",
    "refreshing": "Refreshing...",
    "role": "Role",
    "noUserSelected": "No user selected",
    "save": "Save",
    "saving": "Saving...",
    "table": {
      "noUsers": "No users found.",
      "username": "Username",
      "access": "Access",
      "accessAdmin": "Admin · all devices",
      "created": "Created At",
      "updated": "Updated At",
      "actions": "Actions",
      "editUser": "Edit User",
      "deleteUser": "Delete User"
    },
    "title": "Users",
    "username": "Username",
    "failedToSave": "Failed to save user",
    "failedToDelete": "Failed to delete user",
    "failedToLoad": "Failed to load users: {error}"
  },
  "detectionStatus": {
    "detected": "Detected",
    "suppressionSuccess": "Success",
    "suppressionFailed": "Failed",
    "suppressionInitiated": "Queued",
    "suppressionInProgress": "In Progress",
    "whitelisted": "Whitelisted",
    "lost": "Skipped",
    "unknown": "Unknown"
  },
  "detectionsSunburst": {
    "detection": "detection",
    "detections": "detections",
    "noData": "No Data to visualize",
    "visualizationTitle": "Analytic Report - {serial}",
    "centerText": "of {totalCount} suppression",
    "hoverPrompt": "Hover over a sector. The graph shows statistics for {totalCount} suppressions of detection groups.",
    "frequencyRanges": {
      "0-1": "0-1 GHz",
      "1-2": "1-2 GHz",
      "2-3": "2-3 GHz",
      "3-4": "3-4 GHz",
      "4-5": "4-5 GHz",
      "5-6": "5-6 GHz"
    },
    "stats": {
      "total": "Total",
      "suppressed": "Suppressed",
      "failed": "Failed"
    },
    "statusFilter": {
      "title": "Statuses",
      "showing": "Showing {filtered} of {total}"
    }
  },
  "validation": {
    "required": "{field} is required",
    "invalidNumber": "{field} must be a valid number",
    "provideValidNumber": "Provide a valid number",
    "mustBeInteger": "{field} must be an integer",
    "mustBeAtLeast": "{field} must be at least {min}",
    "mustBeAtMost": "{field} must be at most {max}",
    "mustBeGreaterThan": "{field} must be greater than {min}",
    "mustBeLessThan": "{field} must be less than {max}",
    "mustBeGreaterOrEqual": "{field} must be greater than or equal to {min}",
    "mustBeLessOrEqual": "{field} must be less than or equal to {max}",
    "mustBePositive": "{field} must be positive",
    "cannotExceed": "{field} cannot exceed {max} characters",
    "allowedChars": "Allowed: letters, numbers, dot, hyphen, underscore.",
    "passwordsDoNotMatch": "Passwords do not match",
    "maxTags": "You can assign up to {max} tags",
    "maxGreaterThanMin": "{maxField} must be greater than {minField}",
    "endGreaterThanStart": "End {field} must be greater than Start {field}",
    "login": {
      "usernameRequired": "Username is required",
      "passwordRequired": "Password is required"
    },
    "device": {
      "serialNumberRequired": "Serial Number is required",
      "selectFamily": "Select a device family"
    },
    "deviceSettings": {
      "selectDeviceType": "Select a device type",
      "selectSuppressionMode": "Select a suppression mode",
      "selectSuppressionLogic": "Select a suppression logic",
      "multiChannelsSuppressMin": "Multi channels suppress must be 0 or more",
      "maxSuppressionTimeInvalid": "Max suppression time must be a valid number",
      "maxSuppressionTimeMin": "Max suppression time must be greater than 0",
      "defaultAnalogSuppressionBandwidthInvalid": "Default analog suppression bandwidth must be a valid number",
      "defaultAnalogSuppressionBandwidthMin": "Default analog suppression bandwidth must be one of: {options} MHz",
      "defaultDigitalSuppressionBandwidthInvalid": "Default digital suppression bandwidth must be a valid number",
      "defaultAnalogMultiFrequencySuppressionBandwidthInvalid": "Default multi-frequency suppression bandwidth (analog) must be a valid number",
      "defaultDigitalMultiFrequencySuppressionBandwidthInvalid": "Default multi-frequency suppression bandwidth (digital) must be a valid number",
      "defaultDigitalSuppressionBandwidthMin": "Default digital suppression bandwidth must be one of: {options} MHz",
      "defaultAnalogMultiFrequencySuppressionBandwidthMin": "Default multi-frequency suppression bandwidth (analog) must be one of: {options} MHz",
      "defaultDigitalMultiFrequencySuppressionBandwidthMin": "Default multi-frequency suppression bandwidth (digital) must be one of: {options} MHz",
      "defaultMultiFrequencySuppressionSignalTypeInvalid": "Default multi-frequency signal type must be analog or digital",
      "suppressionTimeMin": "Suppression time must be greater than 0",
      "suppressionMaxCountMin": "Suppression max count must be greater than 0",
      "suppressionInitialDelayInvalid": "Suppression initial delay must be a valid number",
      "suppressionInitialDelayMin": "Suppression initial delay must be at least 0",
      "suppressionMinDetectionsInvalid": "Suppressions max detections count must be a valid number",
      "suppressionMinDetectionsMin": "Suppressions max detections count must be greater than 0",
      "suppressionMinDetectionsMax": "Suppressions max detections count must be at most 20",
      "suppressionMinSnrInvalid": "Suppression min SNR must be a valid number",
      "suppressionMinSnrMin": "Suppression min SNR must be greater than 0",
      "suppressionMinSnrMax": "Suppression min SNR must be at most 30",
      "azimuthInvalid": "Provide a valid azimuth",
      "azimuthMin": "Azimuth must be at least 0",
      "azimuthMax": "Azimuth must be at most 359.99",
      "elevationInvalid": "Provide a valid elevation",
      "elevationMin": "Elevation must be at least 0",
      "latitudeInvalid": "Provide a valid latitude",
      "latitudeMin": "Latitude must be at least -90",
      "latitudeMax": "Latitude must be at most 90",
      "longitudeInvalid": "Provide a valid longitude",
      "longitudeMin": "Longitude must be at least -180",
      "longitudeMax": "Longitude must be at most 180",
      "detectionLifetimeInvalid": "Detection lifetime must be a valid number",
      "detectionLifetimeMin": "Detection lifetime must be greater than 90",
      "minFrequencyInvalid": "Minimum allowed frequency must be a valid number",
      "minFrequencyMin": "Min Allowed Frequency must be greater than 0",
      "maxFrequencyInvalid": "Maximum allowed frequency must be a valid number",
      "maxFrequencyMin": "Max Allowed Frequency must be greater than 0",
      "maxFrequencyGreaterThanMin": "Maximum allowed frequency must be greater than minimum allowed frequency",
      "suppressionAttemptDelayInvalid": "Suppression attempt delay must be a valid number",
      "suppressionAttemptDelayMin": "Suppression attempt delay must be at least 0",
      "txGainInvalid": "TX gain decrease level must be a valid number",
      "txGainMin": "TX Gain Decrease Level must be positive",
      "txGainMax": "TX Gain Decrease Level must be less than 60",
      "fofMinTimeInvalid": "Friend or Foe Min Calculation Time must be a valid number",
      "fofMinTimeMin": "Friend or Foe Min Calculation Time must be at least 1 second",
      "fofMinTimeMax": "Friend or Foe Min Calculation Time must be less than 3600 seconds",
      "fofMaxTimeInvalid": "Friend or Foe Max Calculation Time must be a valid number",
      "fofMaxTimeMin": "Friend or Foe Max Calculation Time must be at least 1 second",
      "fofMaxTimeMax": "Friend or Foe Max Calculation Time must be less than 3600 seconds",
      "alertPatternsTooMany": "You can add up to {max} alert patterns",
      "alertPatternTooLong": "Each alert pattern must be at most {max} characters",
      "alertPatternsInvalid": "Alert patterns must be a list of text values"
    },
    "user": {
      "usernameMinLength": "Username must be at least 3 characters",
      "usernameFormat": "Allowed: letters, numbers, dot, hyphen, underscore.",
      "duplicateGrantTag": "A tag can be assigned only once",
      "passwordMinLength": "Password must be at least 6 characters"
    },
    "password": {
      "currentMinLength": "Current password must be at least 6 characters",
      "newMinLength": "New password must be at least 6 characters",
      "confirmMinLength": "Confirm password must be at least 6 characters",
      "doNotMatch": "Passwords do not match"
    },
    "tag": {
      "nameRequired": "Tag name is required",
      "nameMaxLength": "Tag name must be 64 characters or fewer"
    },
    "frequency": {
      "frequencyInvalid": "Frequency must be a valid number",
      "frequencyMin": "Frequency must be greater than or equal to {min} MHz",
      "frequencyMax": "Frequency must be less than or equal to {max} MHz",
      "startInvalid": "Start frequency must be a valid number",
      "startMin": "Start frequency must be greater than or equal to {min} MHz",
      "startMax": "Start frequency must be less than or equal to {max} MHz",
      "endInvalid": "End frequency must be a valid number",
      "endMin": "End frequency must be greater than or equal to {min} MHz",
      "endMax": "End frequency must be less than or equal to {max} MHz",
      "endGreaterThanStart": "End Frequency must be greater than Start Frequency"
    },
    "scanRanges": {
      "bandRequired": "Band is required",
      "bandInvalid": "Band must be a string",
      "bandMaxLength": "Band cannot exceed 120 characters",
      "groupRequired": "Group is required",
      "groupInvalid": "Group must be a string",
      "groupMaxLength": "Group cannot exceed 120 characters",
      "channelRequired": "Channel is required",
      "channelInvalid": "Channel must be a number",
      "channelInteger": "Channel must be an integer",
      "channelMin": "Channel must be 0 or greater",
      "stepRequired": "Step is required",
      "stepInvalid": "Step must be a number",
      "stepMin": "Step must be greater than 0"
    },
    "suppression": {
      "bandwidthInvalid": "Width must be a valid number",
      "bandwidthMin": "Width must be at least {min} MHz",
      "durationInvalid": "Duration must be a number",
      "durationMax": "Duration must be less than or equal to {max}",
      "durationMin": "Duration must be at least 1",
      "durationRequired": "Duration is required"
    },
    "firmware": {
      "versionRequired": "Version is required",
      "versionMaxLength": "Version must be 32 characters or fewer",
      "versionFormat": "Version must be in MAJOR.MINOR.PATCH format (e.g., 1.0.0)",
      "fileRequired": "Firmware file is required",
      "fileExtension": "File must be .bin, .hex, or .fw",
      "fileSize": "File size must be 100MB or less"
    },
    "broadbandSuppression": {
      "bandwidthInvalid": "Bandwidth must be a valid integer",
      "bandwidthRange": "Bandwidth must be between {min} and {max}",
      "stepInvalid": "Step must be a valid integer",
      "stepRange": "Step must be between {min} and {max}",
      "stepStandingTimeInvalid": "Step standing time must be a valid integer",
      "stepStandingTimeRange": "Step standing time must be between {min} and {max}",
      "stepStandingTimeStep": "Step standing time must be divisible by 5",
      "frequencyRangeMax": "Frequency range (end - start) must not exceed {max} MHz",
      "frequencyListMin": "Add at least two frequencies",
      "frequencyListMax": "You can add at most {max} frequencies",
      "frequencyListUnique": "Frequencies must be unique",
      "frequencySpanMax": "The span between the lowest and highest frequency must not exceed {max} MHz"
    },
    "jumper": {
      "durationInvalid": "Duration must be a valid integer",
      "durationMin": "Duration must be at least {min} min",
      "durationMax": "Duration must not exceed {max} min",
      "spanMax": "Frequency range (end - start) must not exceed {max} MHz",
      "suppressionTimeInvalid": "Suppression time must be a valid integer",
      "suppressionTimeMin": "Suppression time must be at least {min} s",
      "suppressionTimeMax": "Suppression time must be at most {max} s",
      "suppressionMaxCountInvalid": "Max suppression count must be a valid integer",
      "suppressionMaxCountMin": "Max suppression count must be at least {min}",
      "suppressionMaxCountMax": "Max suppression count must be at most {max}",
      "bandwidthInvalid": "Bandwidth must be one of the allowed values"
    }
  },
  "firmwares": {
    "title": "Firmwares",
    "addFirmware": "Add Firmware",
    "refresh": "Refresh",
    "refreshing": "Refreshing...",
    "loading": "Loading firmwares...",
    "loadingAccount": "Loading account...",
    "deleting": "Deleting...",
    "confirmDelete": "Delete Firmware",
    "confirmDeleteDesc": "Are you sure you want to delete firmware version {version}? This action cannot be undone.",
    "failedToDelete": "Failed to delete firmware",
    "deviceModelsPlaceholder": "Select device models...",
    "noDeviceModels": "No device models available",
    "accessDenied": {
      "title": "Access Denied",
      "description": "You don't have permission to view this page."
    },
    "error": {
      "failedToLoad": "Failed to load firmwares: {error}",
      "failedToCreate": "Failed to create firmware"
    },
    "table": {
      "noFirmwares": "No firmwares found. Add your first firmware to get started.",
      "version": "Version",
      "fileName": "File Name",
      "fileSize": "Size",
      "deviceModels": "Device Models",
      "devicesCount": "Devices",
      "createdAt": "Created At",
      "actions": "Actions",
      "deleteFirmware": "Delete Firmware"
    },
    "dialog": {
      "title": "Add Firmware",
      "description": "Upload a firmware file to deploy to your devices.",
      "version": "Version",
      "versionPlaceholder": "1.0.0",
      "versionHint": "Use MAJOR.MINOR.PATCH format (e.g., 1.0.0, 2.1.3)",
      "file": "Firmware File",
      "dropzone": "Click to select or drag and drop",
      "allowedFormats": ".bin, .hex, .fw (max 100MB)",
      "deviceModels": "Device Models",
      "deviceModelsHint": "Select which device models this firmware applies to",
      "upload": "Upload Firmware",
      "uploading": "Uploading..."
    }
  },
  "jumperSession": {
    "alert": {
      "label": "Active jumper session: {startMHz}–{endMHz} MHz",
      "viewDetails": "View details",
      "stop": "Stop"
    },
    "confirmStop": {
      "title": "Stop jumper session",
      "body": "Are you sure you want to stop this jumper session? This action cannot be undone.",
      "cancel": "Cancel",
      "confirm": "Stop session"
    },
    "dialog": {
      "startFrequency": "Start frequency",
      "endFrequency": "End frequency",
      "duration": "Duration",
      "suppressionTime": "Suppression time per frequency",
      "suppressionMaxCount": "Max suppression count per frequency",
      "bandwidth": "Jam bandwidth",
      "submit": "Start",
      "submitting": "Starting...",
      "genericSubmitError": "Failed to start jumper session.",
      "capabilityMissing": "This device does not support jumper sessions."
    },
    "modal": {
      "title": "Active Jumper Session",
      "sessionEnded": "Session ended",
      "stop": "Stop session",
      "linkedGroups": "Linked detection groups",
      "empty": "No linked detection groups found.",
      "initialBadge": "Initial"
    }
  },
  "broadbandSuppressionsDialog": {
    "title": "Broadband Suppressions – {serial}",
    "actions": {
      "create": "Create suppression",
      "suppress": "Suppress",
      "stop": "Stop",
      "repeat": "Repeat suppression",
      "repeatTooltipOffline": "Device must be online to repeat a suppression",
      "repeatTooltipIncomplete": "This suppression cannot be repeated — missing parameters",
      "repeatFailed": "Failed to repeat the suppression",
      "repeatFailedRejected": "The suppression parameters were rejected",
      "repeatFailedDeviceNotFound": "Device not found",
      "repeatFailedForbidden": "You are not allowed to repeat this suppression"
    },
    "form": {
      "signalType": "Signal type",
      "type": {
        "analog": "Analog",
        "digital": "Digital"
      },
      "tabs": {
        "regular": "Regular",
        "solid": "Solid",
        "hopping": "Hopping",
        "multi": "Multi-frequency",
        "jumper": "Jumper"
      },
      "frequencyStart": "Start frequency",
      "frequencyStop": "Stop frequency",
      "bandwidth": "Bandwidth",
      "step": "Step",
      "stepStandingTime": "Step standing time (ms)",
      "duration": "Duration (s)",
      "deviceOffline": "Device offline",
      "creating": "Creating...",
      "submitError": "Failed to create broadband suppression.",
      "genericCreating": "Creating...",
      "genericSubmitError": "Failed to create suppression.",
      "manual": {
        "frequency": "Frequency",
        "offset": "Offset"
      },
      "multi": {
        "frequency": "Frequency",
        "frequencyPlaceholder": "Enter a frequency",
        "frequencyBadge": "{value} MHz",
        "addFrequency": "Add frequency",
        "removeFrequencyValue": "Remove frequency {value} MHz",
        "noFrequencies": "No frequencies added yet"
      }
    },
    "table": {
      "status": "Status",
      "frequency": "Frequency",
      "detailsHeader": "Details",
      "frequencyStart": "Start (MHz)",
      "frequencyStop": "Stop (MHz)",
      "bandwidth": "Bandwidth",
      "step": "Step",
      "stepStandingTime": "Step standing time (ms)",
      "duration": "Duration (s)",
      "createdAt": "Created at",
      "timestamps": "Date/time",
      "detailLabels": {
        "step": "Step: {value} MHz",
        "standingTime": "Hold: {value} ms",
        "bandwidth": "Bandwidth: {value} MHz",
        "frequencies": "Frequencies: {value} MHz"
      },
      "timestampLabels": {
        "created": "Created",
        "started": "Started",
        "finished": "Finished"
      },
      "actions": "Actions",
      "draft": "Draft",
      "loading": "Loading broadband suppressions...",
      "failedToLoad": "Failed to load broadband suppressions.",
      "empty": "No broadband suppressions yet.",
      "pagination": "Showing {start}-{end} of {total}"
    },
    "status": {
      "initiated": "Initiated",
      "in_progress": "In progress",
      "finished": "Finished",
      "stopped": "Stopped",
      "failed": "Failed"
    }
  },
  "alerts": {
    "fallback": "Device alert ({source}/{type})",
    "indicatorLabel": "Active alerts: {count}",
    "popover": {
      "label": "Active alerts"
    },
    "acknowledge": {
      "action": "Acknowledge",
      "noLongerActive": "Alert is no longer active",
      "failed": "Failed to acknowledge the alert"
    },
    "params": {
      "frequencyMhz": "{value} MHz",
      "similarityPercent": "{value}%"
    },
    "pattern": {
      "pattern_detected": "Watched pattern \"{pattern}\" detected at {frequency}"
    }
  }
}
